import { style } from 'typestyle'
export const p4 = style({ padding: '4px' })
